import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import Modal from "../../../components/modal/modal.component";
import {StyledModalContent} from '../../../components/modal/modal.style';
import {disableSwipeToClose} from "../../../utils/tools/modals";

type AvailabilityGuideModalProps = {
    isOpen: boolean;
    onClose: () => void;
};

const AvailabilityGuideModal: React.FC<AvailabilityGuideModalProps> = (props: AvailabilityGuideModalProps) => {

    const {t} = useTranslation();

    const [showGuide, updateShowGuide] = useState<boolean>(false);

    const handleClose = () => {
        props.onClose();
    };

    useEffect(() => {
        handleOpen();
    });

    const handleOpen = () => {
        updateShowGuide(props.isOpen);
    };

    return (
        <Modal
            isOpen={showGuide}
            canDismiss={disableSwipeToClose}
            onDidDismiss={() => handleClose()}>
                <StyledModalContent>
                    <h1 className="title">{t("profileTab.availability.guide.title")}</h1>
                    <div className="content full-height">
						<p>{t("profileTab.availability.guide.intro")}</p>

						<h6><strong>{t("profileTab.availability.guide.adding.title")}</strong></h6>
						<ol>
							<li>{t("profileTab.availability.guide.adding.step1")}</li>
							<li>
								{t("profileTab.availability.guide.adding.step2")}
								<ul>
									<li>{t("profileTab.availability.guide.adding.step21")}</li>
									<li>{t("profileTab.availability.guide.adding.step22")}</li>
									<li>{t("profileTab.availability.guide.adding.step23")}</li>
								</ul>
							</li>
							<li>{t("profileTab.availability.guide.adding.step3")}</li>
							<li>{t("profileTab.availability.guide.adding.step4")}</li>
							<li>{t("profileTab.availability.guide.adding.step5")}</li>
							<li>{t("profileTab.availability.guide.adding.step6")}</li>
						</ol>
						<p>{t("profileTab.availability.guide.adding.summary")}</p>
                    </div>
                </StyledModalContent>
        </Modal>
    );
};

export default AvailabilityGuideModal;
